(self["webpackChunkshine_on"] = self["webpackChunkshine_on"] || []).push([[796],{

/***/ 9863:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5713);
/* harmony import */ var _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(103);
/* harmony import */ var _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n*[data-v-1b12723a] {\n  will-change        : height, padding-top, padding-bottom, margin-top, margin-bottom, opacity;\n  transform          : translateZ(0);\n  backface-visibility: hidden;\n  perspective        : 1000px;\n}\n.expand-enter-active[data-v-1b12723a],\n.expand-leave-active[data-v-1b12723a] {\n  transition: height .4s ease-in-out,\n              padding-top .4s ease-in-out,\n              padding-bottom .4s ease-in-out,\n              margin-top .4s ease-in-out,\n              margin-bottom .4s ease-in-out,\n              opacity .2s ease-in-out;\n  overflow  : hidden;\n}\n.expand-enter[data-v-1b12723a],\n.expand-leave-to[data-v-1b12723a] {\n  height        : 0;\n  padding-top   : 0;\n  padding-bottom: 0;\n  margin-top    : 0;\n  margin-bottom : 0;\n  opacity       : 0;\n}\n", ""]);
// Exports
/* harmony default export */ __webpack_exports__["Z"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 6762:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var scripts_vue_templates_Account__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4753);
/**
 * Customers/Account Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customers/Account template.
 *
 * @namespace account
 * @file vendors@template.account.js
 * @file template.account.js
 *
 */


/***/ }),

/***/ 9508:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RS": function() { return /* binding */ mq_breakpoints; },
/* harmony export */   "ku": function() { return /* binding */ px_breakpoints; }
/* harmony export */ });
/* unused harmony export px_queries */
// EMs
let mq_breakpoints = {
  '--mobile-down': '(max-width: 25.99em)',
  '--mobile-up': '(min-width: 26em)',
  '--phablet-down': '(min-width: 32.49em)',
  '--phablet-up': '(min-width: 32.5em)',
  '--tablet-down': '(max-width: 39.99em)',
  '--tablet-up': '(min-width: 40em)',
  '--tablet-lg-down': '(min-width: 63.99em)',
  '--tablet-lg-up': '(min-width: 64em)',
  '--laptop-down': '(max-width: 71.99em)',
  '--laptop-up': '(min-width: 72em)',
  '--desktop-down': '(max-width: 99.99em)',
  '--desktop-up': '(min-width: 100em)',
  '--ultrawide': '(min-width: 125em)'
}; // Pixels

let px_breakpoints = {
  '--mobile-up': 416,
  '--phablet-up': 520,
  '--tablet-up': 640,
  '--tablet-lg-up': 1024,
  '--laptop-up': 1152,
  '--desktop-up': 1600,
  '--ultrawide': 2000
};
let px_queries = {
  '--mobile-up': '(min-width: 416px)',
  '--phablet-up': '(min-width: 520px)',
  '--tablet-up': '(min-width: 640px)',
  '--tablet-lg-up': '(min-width: 1024px)',
  '--laptop-up': '(min-width: 1152px)',
  '--desktop-up': '(min-width: 1600px)',
  '--ultrawide': '(min-width: 2000px)'
};


/***/ }),

/***/ 4836:
/***/ (function() {

// Element to move, time in ms to animate
window.scrollTo = function (element, duration) {
  var e = document.documentElement;

  if (e.scrollTop === 0) {
    var t = e.scrollTop;
    ++e.scrollTop;
    e = t + 1 === e.scrollTop-- ? e : document.body;
  }

  scrollToC(e, e.scrollTop, element, duration);
}; // Element to move, element or px from, element or px to, time in ms to animate


function scrollToC(element, from, to, duration) {
  if (duration <= 0) return;
  if (typeof from === "object") from = from.offsetTop;
  if (typeof to === "object") to = to.offsetTop;
  scrollToX(element, from, to, 0, 1 / duration, 20, easeOutCuaic);
}

function scrollToX(element, xFrom, xTo, t01, speed, step, motion) {
  if (t01 < 0 || t01 > 1 || speed <= 0) {
    element.scrollTop = xTo;
    return;
  }

  element.scrollTop = xFrom - (xFrom - xTo) * motion(t01);
  t01 += speed * step;
  setTimeout(function () {
    scrollToX(element, xFrom, xTo, t01, speed, step, motion);
  }, step);
}

function easeOutCuaic(t) {
  t--;
  return t * t * t + 1;
}

/***/ }),

/***/ 3200:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.min.js
var vue_min = __webpack_require__(9346);
var vue_min_default = /*#__PURE__*/__webpack_require__.n(vue_min);
;// CONCATENATED MODULE: ./src/scripts/vue/store/global.js

const store = vue_min_default().observable({
  menuActive: false,
  searchActive: false,
  notificationsActive: false,
  closeAnnouncement: false,
  customerCountry: 'NZ'
});
const actions = {
  openMenu() {
    store.menuActive = true;
  },

  toggleMenu() {
    if (store.menuActive) {
      this.closeAll();
    } else {
      this.closeAll();
      store.menuActive = true;
    }
  },

  toggleSearch() {
    store.searchActive = !store.searchActive;
  },

  toggleNotifications() {
    store.notificationsActive = !store.notificationsActive;
  },

  closeAll() {
    store.menuActive = false;
    store.searchActive = false;
    store.notificationsActive = false;
    window.PSTheme.Vue.Header.secondMenuIdx = null;
    window.PSTheme.Vue.Header.thirdMenuIdx = null;
  }

};
(vue_min_default()).prototype.$store = store;
(vue_min_default()).prototype.$actions = actions;
// EXTERNAL MODULE: ./src/scripts/utils/breakpoints.js
var breakpoints = __webpack_require__(9508);
// EXTERNAL MODULE: ./node_modules/@vue/composition-api/dist/vue-composition-api.mjs
var vue_composition_api = __webpack_require__(5706);
// EXTERNAL MODULE: ./node_modules/vue-screen/dist/vue-screen.esm.js
var vue_screen_esm = __webpack_require__(6768);
// EXTERNAL MODULE: ./node_modules/@shopify/theme-currency/currency.js
var currency = __webpack_require__(1186);
// EXTERNAL MODULE: ./node_modules/@shopify/theme-images/images.js
var theme_images_images = __webpack_require__(3253);
;// CONCATENATED MODULE: ./src/scripts/vue/main.js







/* config */

(vue_min_default()).config.devtools = true;
(vue_min_default()).config.productionTip = false;
(vue_min_default()).config.silent = true;
/* extensions */

(vue_min_default()).prototype.$language = window.PSTheme.Language;
(vue_min_default()).prototype.$settings = window.PSTheme.Settings;

(vue_min_default()).prototype.$image = (src, size = '750x') => theme_images_images/* getSizedImageUrl */.M0(src, size);

(vue_min_default()).prototype.$preloadImages = (imgArray, size = '750x') => theme_images_images/* preload */.MA(imgArray, size);

(vue_min_default()).prototype.$money = amount => (0,currency/* formatMoney */.l)(amount, '${{amount}}');

(vue_min_default()).prototype.$isEmpty = obj => {
  if (obj && Object.keys(obj).length === 0 && obj.constructor === Object) return true;
};
/* plugins */


vue_min_default().use(vue_composition_api/* default */.ZP);
vue_min_default().use(vue_screen_esm/* default */.Z, {
  mobile_up: breakpoints/* px_breakpoints.--mobile-up */.ku["--mobile-up"],
  tablet_up: breakpoints/* px_breakpoints.--tablet-up */.ku["--tablet-up"],
  tablet_lg_up: breakpoints/* px_breakpoints.--tablet-lg-up */.ku["--tablet-lg-up"],
  laptop_up: breakpoints/* px_breakpoints.--laptop-up */.ku["--laptop-up"],
  desktop_up: breakpoints/* px_breakpoints.--desktop-up */.ku["--desktop-up"]
});

/***/ }),

/***/ 4753:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _splidejs_splide_dist_css_themes_splide_default_min_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(881);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9346);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var scripts_vue_main__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3200);
/* harmony import */ var scripts_utils_smoothscroll__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4836);
/* harmony import */ var scripts_utils_smoothscroll__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(scripts_utils_smoothscroll__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var local_storage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9982);
/* harmony import */ var local_storage__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(local_storage__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var scripts_utils_breakpoints__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9508);
/* harmony import */ var _splidejs_vue_splide__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5493);
/* harmony import */ var _transitions_TransitionExpand__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6719);





 // import { CountryProvinceSelector, postLink } from '@shopify/theme-common'





window.PSTheme.Vue.Account = new (vue__WEBPACK_IMPORTED_MODULE_7___default())({
  name: 'Account',
  delimiters: ['${', '}'],
  components: {
    Slider: _splidejs_vue_splide__WEBPACK_IMPORTED_MODULE_5__/* .Splide */ .tv,
    Slide: _splidejs_vue_splide__WEBPACK_IMPORTED_MODULE_5__/* .SplideSlide */ .jw,
    TransitionExpand: _transitions_TransitionExpand__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z
  },

  data() {
    return {
      accountState: '',
      accordionClosed: false,
      showPassword: false,
      activeCTA: 'orders',
      points: 0,
      newAddressOpen: false,
      editAddressID: 0,
      outlet: false,
      userToken: null,
      preorders: null,
      preorder_products: [],
      returnsData: null,
      returnsResponse: null,
      returnsPolicy: null,
      returnsMessage: null,
      returnsValidation: null,
      loading: false,
      carouselOptions: {
        perPage: 4,
        perMove: 1,
        pagination: false,
        gap: '.25rem',
        breakpoints: {
          [scripts_utils_breakpoints__WEBPACK_IMPORTED_MODULE_4__/* .px_breakpoints["--desktop-up"] */ .ku["--desktop-up"]]: {
            perPage: 3,
            padding: {
              right: '0'
            }
          },
          [scripts_utils_breakpoints__WEBPACK_IMPORTED_MODULE_4__/* .px_breakpoints["--laptop-up"] */ .ku["--laptop-up"]]: {
            perPage: 2,
            padding: {
              right: '0'
            }
          },
          [scripts_utils_breakpoints__WEBPACK_IMPORTED_MODULE_4__/* .px_breakpoints["--tablet-up"] */ .ku["--tablet-up"]]: {
            perPage: 1,
            padding: {
              right: '2rem'
            }
          }
        }
      }
    };
  },

  mounted() {
    console.log('running..');
    this.accountState = window.location.pathname;
    this.activeCTA = this.accountState.includes('addresses') ? 'addresses' : 'orders';

    if (window.location.search.includes('view-preorders')) {
      this.updateAccountState('/account?view-preorders', true);
      this.activeCTA = 'preorders';
      this.getPreorders(this.$refs.customer.id);
    }

    if (document.getElementsByTagName('html')[0].classList.contains('outlet')) this.outlet = true;
  },

  watch: {
    accountState: {
      immediate: true,

      handler() {
        window.scrollTo(0, 500);

        switch (this.activeCTA) {
          case 'orders':
            window.addEventListener('smile-ui-loaded', event => {
              console.log('SMILEUI READY!');
            });
            break;

          case 'addresses':
            setTimeout(() => {
              // Initialize listeners on address selectors, callback in shopify_common.js
              new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
                hideElement: 'AddressProvinceContainerNew'
              }); // Initialize each edit form's country/province selector

              document.querySelectorAll('.address-country-option').forEach(option => {
                const {
                  formId
                } = option.dataset;
                const countrySelector = `AddressCountry_${formId}`;
                const provinceSelector = `AddressProvince_${formId}`;
                const containerSelector = `AddressProvinceContainer_${formId}`;
                new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
                  hideElement: containerSelector
                });
              });
            }, 3000);
            break;

          case 'returns':
            if (!this.returnsPolicy) {
              let url = '/pages/returns-portal-policy?view=page-content';
              if (this.outlet) url = '/pages/outlet-returns-portal-policy?view=page-content';
              fetch(url).then(res => res.text()).then(html => {
                this.returnsPolicy = html;
              });
            }

            break;
        }
      }

    },

    preorders() {
      if (this.preorders.message !== 'success') return;
      this.preorder_products = [];
      this.loading = this.preorders && this.preorders.data.length !== 0;

      if (this.preorders && this.preorders.data.length !== 0) {
        this.preorders.data.forEach(item => {
          let productData = {};

          try {
            fetch(`/products/${item.handle}.js`).then(res => {
              if (!res.ok) {
                throw new Error('Product not found.');
              } else {
                return res.json();
              }
            }).then(data => {
              productData = {
                has_shopify_data: true,
                ...data
              };
            });
          } catch (err) {
            console.log(err);
          }

          productData.preorder_title = item.title;
          productData.etd_new = item.ETD_new, productData.etd_old = item.ETD_old, productData.order_token = item.order_token, productData.order_ref = item.order_ref;
          this.preorder_products.push(productData);
        });
      }

      this.loading = false;
    }

  },
  methods: {
    updateAccountState(pathname, async = false) {
      this.loading = true;
      this.accordionClosed = this.accountState === pathname && this.accordionClosed === false;
      this.accountState = pathname;
      const url = window.location.origin + this.accountState;
      window.history.replaceState({
        path: null
      }, '', url);

      if (!async) {
        this.loading = false;
      }
    },

    print() {
      window.print();
    },

    getPreorders(customerId) {
      if (!this.preorders) {
        fetch(`/a/ps/${customerId}/preorder`).then(res => res.json()).then(data => {
          this.preorders = data;
        }).catch(err => {
          console.log(err);
        });
      } else {
        this.loading = false;
      }
    },

    sendRequestReturn(e, userId, email) {
      this.loading = true;
      window.scrollTo(0, 500);
      const form = e.target;
      const formData = {
        ref: form.dataset.order_ref,
        email,
        reason: form.querySelector('select[name="reason"]').value,
        items: []
      };
      form.querySelectorAll('table.line-item').forEach(item => {
        if (Number(item.querySelector('input[name="quantity"]').value) > 0) {
          formData.items.push({
            name: item.dataset.name,
            qty: Number(item.querySelector('input[name="quantity"]').value),
            comments: item.querySelector('textarea[name="comment"]').value,
            productOptionId: Number(item.dataset.product_option_id)
          });
        }
      });

      if (formData.items.length === 0) {
        this.loading = false;
        this.returnsValidation = 'Please specify a quantity for the items you are returning.';
      } else {
        const requestOptions = {
          headers: {
            'Content-Type': 'application/json',
            'Custom-Token': this.userToken
          },
          method: 'POST',
          body: JSON.stringify(formData),
          redirect: 'follow'
        };
        fetch(`/a/ps/${userId}/return/${formData.ref}`, requestOptions).then(res => res.json()).then(data => {
          this.returnsMessage = data.message;
          this.returnsResponse = data.data;
          this.loading = false;
          this.returnsValidation = null;

          if (data.message == 'success') {
            local_storage__WEBPACK_IMPORTED_MODULE_3___default()(`PSReturn_${formData.ref}`, true);
          }
        }).catch(error => {
          console.log('error', error);
          window.open('https://shineon.partytime.nz/return', '_blank');
          this.returnsData = null;
          this.loading = false;
          this.returnsValidation = null;
          this.updateAccountState('/account');
          this.activeCTA = 'orders';
        });
      }
    },

    getRequestReturn(userId, userToken, orderName) {
      this.userToken = userToken;
      this.returnsData = null;
      this.updateAccountState(`/account?return-request=${userId}-${userToken}-${orderName}`, true);
      this.activeCTA = 'returns';
      fetch(`/a/ps/${userId}/return/${orderName}`, {
        mode: 'same-origin',
        cache: 'no-cache',
        headers: {
          'Content-Type': 'application/json',
          'Custom-Token': userToken
        }
      }).then(res => res.json()).then(data => {
        if (data.message === 'success') {
          this.returnsData = data;
          this.loading = false;
        } else {
          window.open('https://shineon.partytime.nz/return', '_blank');
          this.returnsData = null;
          this.loading = false;
          this.updateAccountState('/account');
          this.activeCTA = 'orders';
        }
      }).catch(error => {
        console.log('error', error);
        window.open('https://shineon.partytime.nz/return', '_blank');
        this.returnsData = null;
        this.loading = false;
        this.updateAccountState('/account');
        this.activeCTA = 'orders';
      });
    },

    returnRequestSent(ref) {
      if (local_storage__WEBPACK_IMPORTED_MODULE_3___default()(`PSReturn_${ref}`)) {
        return true;
      }
    },

    decrementQuantity(e) {
      const qtyInput = e.target.parentNode.querySelector('input');
      if (qtyInput.value == 0) return;
      qtyInput.value = Number(qtyInput.value) - 1;
    },

    incrementQuantity(e) {
      const qtyInput = e.target.parentNode.querySelector('input');
      if (qtyInput.value == qtyInput.max) return;
      qtyInput.value = Number(qtyInput.value) + 1;
    },

    deleteAddress(formID) {
      Shopify.postLink(`/account/addresses/${formID}`, {
        parameters: {
          _method: 'delete'
        }
      });
    }

  }
}).$mount('.account');

/***/ }),

/***/ 9982:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var stub = __webpack_require__(5354);

var parse = __webpack_require__(4872);

var tracking = __webpack_require__(1235);

var ls = 'localStorage' in __webpack_require__.g && __webpack_require__.g.localStorage ? __webpack_require__.g.localStorage : stub;

function accessor(key, value) {
  if (arguments.length === 1) {
    return get(key);
  }

  return set(key, value);
}

function get(key) {
  const raw = ls.getItem(key);
  const parsed = parse(raw);
  return parsed;
}

function set(key, value) {
  try {
    ls.setItem(key, JSON.stringify(value));
    return true;
  } catch (e) {
    return false;
  }
}

function remove(key) {
  return ls.removeItem(key);
}

function clear() {
  return ls.clear();
}

function backend(store) {
  store && (ls = store);
  return ls;
}

accessor.set = set;
accessor.get = get;
accessor.remove = remove;
accessor.clear = clear;
accessor.backend = backend;
accessor.on = tracking.on;
accessor.off = tracking.off;
module.exports = accessor;

/***/ }),

/***/ 4872:
/***/ (function(module) {

"use strict";


function parse(rawValue) {
  const parsed = parseValue(rawValue);

  if (parsed === undefined) {
    return null;
  }

  return parsed;
}

function parseValue(rawValue) {
  try {
    return JSON.parse(rawValue);
  } catch (err) {
    return rawValue;
  }
}

module.exports = parse;

/***/ }),

/***/ 5354:
/***/ (function(module) {

"use strict";


var ms = {};

function getItem(key) {
  return key in ms ? ms[key] : null;
}

function setItem(key, value) {
  ms[key] = value;
  return true;
}

function removeItem(key) {
  var found = (key in ms);

  if (found) {
    return delete ms[key];
  }

  return false;
}

function clear() {
  ms = {};
  return true;
}

module.exports = {
  getItem: getItem,
  setItem: setItem,
  removeItem: removeItem,
  clear: clear
};

/***/ }),

/***/ 1235:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var parse = __webpack_require__(4872);

var listeners = {};
var listening = false;

function listen() {
  if (__webpack_require__.g.addEventListener) {
    __webpack_require__.g.addEventListener('storage', change, false);
  } else if (__webpack_require__.g.attachEvent) {
    __webpack_require__.g.attachEvent('onstorage', change);
  } else {
    __webpack_require__.g.onstorage = change;
  }
}

function change(e) {
  if (!e) {
    e = __webpack_require__.g.event;
  }

  var all = listeners[e.key];

  if (all) {
    all.forEach(fire);
  }

  function fire(listener) {
    listener(parse(e.newValue), parse(e.oldValue), e.url || e.uri);
  }
}

function on(key, fn) {
  if (listeners[key]) {
    listeners[key].push(fn);
  } else {
    listeners[key] = [fn];
  }

  if (listening === false) {
    listen();
  }
}

function off(key, fn) {
  var ns = listeners[key];

  if (ns.length > 1) {
    ns.splice(ns.indexOf(fn), 1);
  } else {
    listeners[key] = [];
  }
}

module.exports = {
  on: on,
  off: off
};

/***/ }),

/***/ 6719:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TransitionExpand; }
});

;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/transitions/TransitionExpand.vue?vue&type=template&id=1b12723a&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"expand"},on:{"enter":_vm.enter,"after-enter":_vm.afterEnter,"leave":_vm.leave}},[_vm._t("default")],2)}
var staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/transitions/TransitionExpand.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var TransitionExpandvue_type_script_lang_js_ = ({
  name: 'TransitionExpand',
  props: {
    fixedEntryHeight: {
      type: String,
      required: false,
      default: null
    },
    linear_padding: {
      type: String,
      required: false,
      default: ''
    },
    linear_margin: {
      type: String,
      required: false,
      default: ''
    }
  },
  methods: {
    enter(element) {
      element.style.height = this.fixedEntryHeight || element.scrollHeight + 'px';
      element.style.opacity = 1;

      if (this.linear_padding !== '') {
        element.style.paddingTop = this.linear_padding;
        element.style.paddingBottom = this.linear_padding;
      }

      if (this.linear_margin !== '') {
        element.style.marginTop = this.linear_margin;
        element.style.marginBottom = this.linear_margin;
      }
    },

    afterEnter(element) {
      element.style.height = 'auto';
    },

    leave(element) {
      element.style.height = element.scrollHeight + 'px';
      setTimeout(() => {
        element.style.height = 0;
        element.style.opacity = 0;

        if (this.linear_padding !== '') {
          element.style.paddingTop = 0;
          element.style.paddingBottom = 0;
        }

        if (this.linear_margin !== '') {
          element.style.marginTop = 0;
          element.style.marginBottom = 0;
        }
      }, 50);
    }

  }
});
;// CONCATENATED MODULE: ./src/scripts/vue/transitions/TransitionExpand.vue?vue&type=script&lang=js&
 /* harmony default export */ var transitions_TransitionExpandvue_type_script_lang_js_ = (TransitionExpandvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js
var injectStylesIntoStyleTag = __webpack_require__(3379);
var injectStylesIntoStyleTag_default = /*#__PURE__*/__webpack_require__.n(injectStylesIntoStyleTag);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/styleDomAPI.js
var styleDomAPI = __webpack_require__(7795);
var styleDomAPI_default = /*#__PURE__*/__webpack_require__.n(styleDomAPI);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/insertBySelector.js
var insertBySelector = __webpack_require__(569);
var insertBySelector_default = /*#__PURE__*/__webpack_require__.n(insertBySelector);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js
var setAttributesWithoutAttributes = __webpack_require__(3565);
var setAttributesWithoutAttributes_default = /*#__PURE__*/__webpack_require__.n(setAttributesWithoutAttributes);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/insertStyleElement.js
var insertStyleElement = __webpack_require__(9216);
var insertStyleElement_default = /*#__PURE__*/__webpack_require__.n(insertStyleElement);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/styleTagTransform.js
var styleTagTransform = __webpack_require__(4589);
var styleTagTransform_default = /*#__PURE__*/__webpack_require__.n(styleTagTransform);
// EXTERNAL MODULE: ./node_modules/@ps-devs/shopify-webpack/node_modules/css-loader/dist/cjs.js??clonedRuleSet-5[0].rules[0].use[1]!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/transitions/TransitionExpand.vue?vue&type=style&index=0&id=1b12723a&scoped=true&lang=css&
var TransitionExpandvue_type_style_index_0_id_1b12723a_scoped_true_lang_css_ = __webpack_require__(9863);
;// CONCATENATED MODULE: ./node_modules/style-loader/dist/cjs.js!./node_modules/@ps-devs/shopify-webpack/node_modules/css-loader/dist/cjs.js??clonedRuleSet-5[0].rules[0].use[1]!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/transitions/TransitionExpand.vue?vue&type=style&index=0&id=1b12723a&scoped=true&lang=css&

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (styleTagTransform_default());
options.setAttributes = (setAttributesWithoutAttributes_default());

      options.insert = insertBySelector_default().bind(null, "head");
    
options.domAPI = (styleDomAPI_default());
options.insertStyleElement = (insertStyleElement_default());

var update = injectStylesIntoStyleTag_default()(TransitionExpandvue_type_style_index_0_id_1b12723a_scoped_true_lang_css_/* default */.Z, options);




       /* harmony default export */ var transitions_TransitionExpandvue_type_style_index_0_id_1b12723a_scoped_true_lang_css_ = (TransitionExpandvue_type_style_index_0_id_1b12723a_scoped_true_lang_css_/* default */.Z && TransitionExpandvue_type_style_index_0_id_1b12723a_scoped_true_lang_css_/* default.locals */.Z.locals ? TransitionExpandvue_type_style_index_0_id_1b12723a_scoped_true_lang_css_/* default.locals */.Z.locals : undefined);

;// CONCATENATED MODULE: ./src/scripts/vue/transitions/TransitionExpand.vue?vue&type=style&index=0&id=1b12723a&scoped=true&lang=css&

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1900);
;// CONCATENATED MODULE: ./src/scripts/vue/transitions/TransitionExpand.vue



;


/* normalize component */

var component = (0,componentNormalizer/* default */.Z)(
  transitions_TransitionExpandvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "1b12723a",
  null
  
)

/* harmony default export */ var TransitionExpand = (component.exports);

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [346,383,67], function() { return __webpack_exec__(6762); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ }
]);